/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/dropbox" */ '@atlassian/logo-third-party/dropbox'
		).then((m) => m.DropboxIcon),
	{ moduleId: '@atlassian/logo-third-party/dropbox' },
);

const LazyDropboxIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-dropbox" */ './utils').then((m) => m.DropboxIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/dropbox/icon' },
);

const LazyDropboxSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-dropbox-search-result" */ './utils').then(
			(m) => m.DropboxSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const DropboxIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyDropboxIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const DropboxSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyDropboxSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
